export function blankToNull<T extends string | null | undefined>(value: T): T {
  return (typeof value === 'string' && value.trim() === '' ? null : value) as T;
}
